/**
 * Custom-card helpers for Scope Console (API 11–12).
 * Persistence is the scope-record PATCH; the console re-fetches after every mutation.
 */

const CUSTOM_CARD_ROLE_TAGS = new Set(['KAM', 'TCSM', 'OPS']);

/**
 * Who can set/edit/remove a custom card.
 * Prefer explicit BE flag; else KAM / Technical CSM / Ops head on the sales roster.
 */
export const canManageCustomCard = (email, team, recordCapability) => {
  if (typeof recordCapability === 'boolean') return recordCapability;
  const e = (email || '').trim().toLowerCase();
  if (!e) return false;
  const hit = (team?.allRoster || []).find(u => (u.email || '').trim().toLowerCase() === e);
  if (hit?.roleTag && CUSTOM_CARD_ROLE_TAGS.has(hit.roleTag)) return true;
  return false;
};

export const actorDisplayName = (email, team) => {
  const e = (email || '').trim().toLowerCase();
  const hit = (team?.allRoster || []).find(u => (u.email || '').trim().toLowerCase() === e);
  if (hit?.name) return hit.name;
  if (!email) return 'Internal';
  return email.split('@')[0] || email;
};

/** Parse a custom-card day field: 1–60 or Quote. */
export const parseCustomDay = v => {
  const s = String(v ?? '').trim();
  if (/^quote$/i.test(s)) return 'Quote';
  if (/^\d+$/.test(s)) {
    const n = parseInt(s, 10);
    if (n >= 1 && n <= 60) return n;
  }
  return undefined;
};

export const todayLabel = (d = new Date()) => {
  try {
    return new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric', year: 'numeric' }).format(d);
  } catch {
    return d.toISOString().slice(0, 10);
  }
};
